'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentPaymillAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.5665 27.933C18.5886 27.9822 18.6006 28.0366 18.6006 28.0937C18.6006 28.1509 18.5886 28.2053 18.5665 28.2545V28.255L16.5652 32.4377L16.5641 32.4386C16.4082 32.744 16.1372 32.9877 15.7684 32.9877L13.621 32.9873C13.3882 32.9873 13.1998 32.8049 13.1998 32.5798C13.1998 32.5214 13.2128 32.4665 13.2357 32.4162L15.2544 28.2899L15.2541 28.2865C15.286 28.229 15.3062 28.164 15.3062 28.0938C15.3062 28.0238 15.2544 27.8976 15.2544 27.8976L13.2353 23.7718L13.2357 23.7714C13.2128 23.7213 13.1998 23.6661 13.1998 23.6078C13.1998 23.3827 13.3883 23.2002 13.621 23.2002L15.7684 23.2C16.1372 23.2 16.424 23.4437 16.5641 23.7488L16.5652 23.7497L18.5665 27.9325V27.933ZM25.5874 30.9987H24.4718V34.9266H22.645V24.5049H25.7973C28.0605 24.5049 29.7742 25.5376 29.7742 27.6658C29.7741 29.8409 28.1899 30.9987 25.5874 30.9987ZM25.652 25.8975H24.472V29.6062H25.6035C27.2363 29.6062 27.9315 28.9645 27.9315 27.7127C27.9314 26.586 27.2846 25.8975 25.652 25.8975ZM31.1515 34.9266H29.3251L33.4312 24.5049H35.1929L39.3801 34.9266H37.3916L36.5511 32.6889H31.9925L31.1515 34.9266ZM34.8858 28.2762C34.5626 27.3996 34.2719 26.4767 34.2719 26.4767H34.2393C34.2393 26.4767 33.9645 27.4156 33.6251 28.2762C33.6251 28.2762 32.5259 31.2492 32.5097 31.2492H36.0014L34.8858 28.2762ZM42.8741 34.9266V30.9833L46.3659 24.5049H44.5877L42.0499 29.3402H42.0335L39.4955 24.5049H37.4588L41.0475 30.9833V34.9266H42.8741ZM51.7056 34.9449L49.5232 28.9047C49.2808 28.2008 49.0383 27.4339 49.0383 27.4339H49.0059C49.0059 27.4339 48.9411 28.2475 48.8608 28.9518L48.1008 34.9448H46.4356L47.9068 24.5232H49.6689L52.061 31.2521C52.3682 32.0811 52.6594 33.0984 52.6594 33.0984H52.6917C52.6917 33.0984 52.9987 32.0811 53.306 31.2521L55.7309 24.5232H57.4928L58.964 34.9448H57.1047L56.3127 28.9204C56.2156 28.2008 56.1349 27.4339 56.1349 27.4339H56.1026C56.1026 27.4339 55.8761 28.2008 55.6336 28.9047L53.4837 34.9449H51.7056ZM60.6328 24.5234V34.9449V34.945H62.4593V24.5234H60.6328ZM64.4247 34.9449V24.5234H66.2511V33.5054H70.3572V34.945H64.4247V34.9449ZM72.2742 24.5234V34.9449V34.945H78.2067V33.5054H74.1009V24.5234H72.2742ZM13.4596 26.8703C13.4596 26.6451 13.2707 26.4626 13.0381 26.4626L10.8908 26.4624C10.5791 26.4624 10.2974 26.6221 10.1617 26.8702L5.82895 35.6787C5.80603 35.7287 5.79309 35.7841 5.79309 35.8421C5.79309 36.0672 5.98171 36.2496 6.21438 36.2496L8.36161 36.25C8.73049 36.25 9.0381 35.9449 9.15843 35.7004L13.4244 27.0337H13.4238C13.4464 26.9834 13.4596 26.9285 13.4596 26.8703Z",
          fill: "#F05000"
        }
      )
    ]
  }
);
const VpPaymentPaymillAsset = forwardRef(PaymentPaymillAsset);

export { VpPaymentPaymillAsset as default };
